
import {
    OPEN_SUBSCRIPTION_MODAL,
    CLOSE_SUBSCRIPTION_MODAL,
    OPEN_FORGOT_PASS_MODAL,
    CLOSE_FORGOT_PASS_MODAL
} from './actionTypes';

export function openSubscriptionModal() {
    return {
        type: OPEN_SUBSCRIPTION_MODAL
    }
}

export function closeSubscriptionModal() {
    return {
        type: CLOSE_SUBSCRIPTION_MODAL
    }
}

export function openForgotPassModal() {
    return {
        type: OPEN_FORGOT_PASS_MODAL
    }
}

export function closeForgotPassModal() {
    return {
        type: CLOSE_FORGOT_PASS_MODAL
    }
}